import type { AboutNarrativeData } from '@/data/types';

interface AboutNarrativeProps {
  data: AboutNarrativeData;
}

export function AboutNarrative({ data }: AboutNarrativeProps) {
  return (
    <section className="bg-gray-800 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-red-500 mb-6">
            {data.title}
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
            {data.description}
          </p>
        </div>
      </div>
    </section>
  );
}